import { AxiosResponse } from 'axios';
import client from './clientRetryable';
import IdDocType from '@/resources/enum/IdDocType';
import getAuthHeader from '@/util/getAuthHeader';
import MnDocType from '@/resources/enum/MnDocType';

export default {
  async fetchClientTypes(kycRequestID: number, isPC: boolean): Promise<AxiosResponse<void>> {
    const clientType: number = isPC ? 3 : 1;
    const request: RequestClientTypes = { clientType };
    const response: AxiosResponse<void> = await client.put<void>(`kyc_requests/${kycRequestID}/client_types`, request, {
      headers: getAuthHeader()
    });
    return response;
  },

  async fetchIdDocTypes(kycRequestID: number, request: RequestIdDocTypes): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(`kyc_requests/${kycRequestID}/id_doc_types`, request, {
      headers: getAuthHeader()
    });
    return response;
  },

  async fetchMnDocTypes(kycRequestID: number, request: RequestMnDocTypes): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(
      `kyc_requests/${kycRequestID}/my_number_doc_types`,
      request,
      {
        headers: getAuthHeader()
      }
    );
    return response;
  },

  async fetchGpDocTypes(kycRequestID: number, request: RequestGpDocTypes): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(
      `kyc_requests/${kycRequestID}/general_doc_types`,
      request,
      {
        headers: getAuthHeader()
      }
    );
    return response;
  },

  async fetchOpDocTypes(kycRequestID: number, request: RequestOpDocTypes): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(
      `kyc_requests/${kycRequestID}/optional_doc_types`,
      request,
      {
        headers: getAuthHeader()
      }
    );
    return response;
  },

  async confirm(kycRequestID: number): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(`kyc_requests/${kycRequestID}/confirm`, null, {
      headers: getAuthHeader()
    });
    return response;
  }
};

interface RequestClientTypes {
  clientType: number;
}

export interface RequestIdDocTypes {
  idDocType: IdDocType;
}

interface RequestMnDocTypes {
  myNumberDocType: MnDocType;
}

interface RequestGpDocTypes {
  generalDocType: string;
}

interface RequestOpDocTypes {
  seqNo: number;
  optionalDocType: string;
}
